<template>
  <div :class="jel_getClassObject(content)">
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libDateDeNaissance"
      :rules="`required|is_valid_date|is_age_requis`"
      tag="div"
    >
      <!-- TODO:
      vee-validate V3 ne supporte plus date_format : custom validation?
      rules="required|date_format:yyyy/MM/dd|date_between:2016/10/09,2020/20/09"
    -->
      <b-form-group :label="content.libDateDeNaissance" label-for="dateDeNaissance">
        <b-form-input
          :id="content.idHTML ? content.idHTML : 'dateDeNaissance'"
          v-model="dateDeNaissance"
          type="tel"
          class="text-center font-weight-bold texte"
          :maxlength="$t('compte.dateDeNaissance.placeholder').length"
          :state="getValidationState(validationContext)"
          @keydown.enter="getValidationState(validationContext)"
          @keyup.native="maskDateDeNaissance($event)"
        ></b-form-input>
        <ErreurValidation
          id="dateDeNaissance-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';
import i18n from '@/js/i18n';

export default {
  name: 'FormulaireDateDeNaissance',

  components: { ErreurValidation },
  props: { content: { type: Object, required: true } },
  computed: {
    dateDeNaissance: {
      get() {
        return this.$store.state.compte.dateDeNaissance;
      },
      set(value) {
        this.$store.commit('compte/SET_DATE_DE_NAISSANCE', value);
      },
    },
  },
  methods: {
    // Passe-passe permettant de correcterment positionner le curseur sur delete/backspace
    // TODO: Un seul cas qui n'est pas traiter: backspace pour passer d'un bloc à l'autre (idem Telephone)
    maskDateDeNaissance(e) {
      // Inspiration: https://github.com/vuejs-tips/vue-the-mask/issues/56
      let caretPosition = e.target.selectionStart;
      // Match the masked characters using "/"
      const lastAmountOfSpaces = (e.target.value.match(/[\s//]/g) || []).length;
      const regEx =
        i18n.locale == 'en' ? /(\d{0,4})(\d{0,2})(\d{0,2})/ : /(\d{0,2})(\d{0,2})(\d{0,4})/;
      const replacedInput = e.target.value.replace(/\D/g, '').match(regEx);
      const formattedValue = !replacedInput[2]
        ? replacedInput[1]
        : `${replacedInput[1]}/${replacedInput[2]}${
            replacedInput[3] ? `/${replacedInput[3]}` : ''
          }`;
      this.dateDeNaissance = formattedValue;

      if (formattedValue === e.target.value) {
        return;
      }
      // Match the masked characters using "/"
      const newAmountOfSpaces = (formattedValue.match(/[\s//]/g) || []).length;
      caretPosition += newAmountOfSpaces - lastAmountOfSpaces;

      this.$nextTick(function () {
        e.target.setSelectionRange(caretPosition, caretPosition);
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      if (validated && !valid) {
        return valid;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Cacher les flèches sur input type number */
/* Inspiration: https://www.w3schools.com/howto/howto_css_hide_arrow_number.asp */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
